import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { getAppConfigShared } from "../../../ducks/appConfig";
import { useProjectLayerLegendExpanded } from "../../../hooks/project/useProjectLayerProp";

export const useLegendExpand = (layerName: string, isLegendExpanded: boolean) => {
  const shared = useSelector(getAppConfigShared);
  const [expanded, setExpanded] = useState(isLegendExpanded);
  const prevExpanded = useRef(isLegendExpanded);
  const [, toggleLegend] = useProjectLayerLegendExpanded({ name: layerName, isLegendExpanded: expanded });

  const toggleExpanded = useCallback(() => {
    setExpanded(isExpanded => !isExpanded);

    if (!shared) {
      toggleLegend();
    }
  }, [shared, toggleLegend]);

  useEffect(() => {
    if (prevExpanded.current !== isLegendExpanded) {
      prevExpanded.current = isLegendExpanded;

      if (!shared) {
        setExpanded(isLegendExpanded);
      }
    }
  }, [isLegendExpanded]);

  return [expanded, toggleExpanded] as const;
};
